var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c(
        "div",
        {
          staticClass: "sidecart__line-item",
          class: _vm.itemClass,
          style: _vm.orderStyle,
        },
        [
          _c("div", { staticClass: "sidecart__line-item__image-wrapper" }, [
            _c("a", { attrs: { href: _vm.item.url } }, [
              _c("img", {
                staticClass: "sidecart__line-item__image",
                attrs: {
                  src: _vm._f("image")(_vm.item.image, "220x"),
                  alt: _vm.item.product_title,
                },
              }),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "sidecart__line-item__content" },
            [
              _c(
                "div",
                { staticClass: "sidecart__line-item__header" },
                [
                  _c("div", { staticClass: "sidecart__info" }, [
                    _c("a", { attrs: { href: _vm.item.url } }, [
                      _c("p", {
                        staticClass: "sidecart__line-item__title",
                        domProps: { innerHTML: _vm._s(_vm.itemName) },
                      }),
                    ]),
                    _c(
                      "div",
                      { staticClass: "sidecart__line-item__list" },
                      _vm._l(_vm.formattedProductOptions, function (option) {
                        return _c(
                          "p",
                          { staticClass: "sidecart__line-item__option p-m" },
                          [
                            _vm._v(
                              _vm._s(("" + Object.values(option)).toLowerCase())
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "sidecart__line-item__list" }, [
                      _vm.isFinalSale
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "sidecart__line-item__list__price--discount",
                            },
                            [_vm._v("Final Sale (No Returns or Exchanges)")]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _c("icon-button", {
                    staticClass: "sidecart__line-item__remove",
                    attrs: { label: "Remove", icon: "icon-remove" },
                    on: { click: _vm.removeItem },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "sidecart__line-item__details" }, [
                _c(
                  "div",
                  { staticClass: "sidecart__line-item__quantity" },
                  [
                    _c("icon-button", {
                      staticClass: "sidecart__line-item__quantity__change",
                      attrs: { label: "Decrement Count", icon: "icon-minus" },
                      on: { click: _vm.decrement },
                    }),
                    _c(
                      "p",
                      {
                        staticClass:
                          "sidecart__line-item__quantity__label p-mono",
                      },
                      [_vm._v(_vm._s(_vm.item.quantity))]
                    ),
                    _c("icon-button", {
                      staticClass: "sidecart__line-item__quantity__change",
                      attrs: {
                        label: "Increment Count",
                        icon: "icon-plus",
                        size: "9px",
                      },
                      on: { click: _vm.increment },
                    }),
                  ],
                  1
                ),
                _c("p", { staticClass: "sidecart__line-item__price" }, [
                  _vm.isDiscounted || _vm.isGiftWithPurchase
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "p-m sidecart__line-item__price--compare-at",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("money")(
                                _vm.isGiftWithPurchase
                                  ? _vm.item.line_price
                                  : _vm.comparePrice
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isGiftWithPurchase
                    ? _c(
                        "span",
                        {
                          staticClass: "p-m",
                          class: {
                            "sidecart__line-item__price--discount":
                              _vm.isDiscounted,
                          },
                        },
                        [_vm._v(_vm._s(_vm._f("money")(_vm.item.line_price)))]
                      )
                    : _vm._e(),
                  _c("span", {
                    staticClass: "p-m sidecart__line-item__price--discount",
                  }),
                ]),
              ]),
              _vm._l(_vm.item.discounts, function (discount) {
                return _c(
                  "div",
                  { staticClass: "sidecart__line-item__message" },
                  [_vm._v(_vm._s(discount.title))]
                )
              }),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }